/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityInfo } from './FacilityInfo';
import {
    FacilityInfoFromJSON,
    FacilityInfoFromJSONTyped,
    FacilityInfoToJSON,
} from './FacilityInfo';
import type { PatientInfo } from './PatientInfo';
import {
    PatientInfoFromJSON,
    PatientInfoFromJSONTyped,
    PatientInfoToJSON,
} from './PatientInfo';
import type { TargetCompany } from './TargetCompany';
import {
    TargetCompanyFromJSON,
    TargetCompanyFromJSONTyped,
    TargetCompanyToJSON,
} from './TargetCompany';

/**
 * 
 * @export
 * @interface CreateCallExecutionRequest
 */
export interface CreateCallExecutionRequest {
    /**
     * 
     * @type {FacilityInfo}
     * @memberof CreateCallExecutionRequest
     */
    facility?: FacilityInfo;
    /**
     * 
     * @type {TargetCompany}
     * @memberof CreateCallExecutionRequest
     */
    target_company: TargetCompany;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCallExecutionRequest
     */
    goal_list: Array<string>;
    /**
     * 
     * @type {PatientInfo}
     * @memberof CreateCallExecutionRequest
     */
    patient_info?: PatientInfo;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateCallExecutionRequest
     */
    conference_phone_numbers?: Array<string>;
    /**
     * The phone number to call
     * @type {string}
     * @memberof CreateCallExecutionRequest
     */
    target_phone_number?: string;
    /**
     * The ID of the user initiating the call
     * @type {string}
     * @memberof CreateCallExecutionRequest
     */
    user_id?: string;
    /**
     * The name of the user initiating the call
     * @type {string}
     * @memberof CreateCallExecutionRequest
     */
    user_name?: string;
    /**
     * The state where the member resides
     * @type {string}
     * @memberof CreateCallExecutionRequest
     */
    member_state?: string;
}

/**
 * Check if a given object implements the CreateCallExecutionRequest interface.
 */
export function instanceOfCreateCallExecutionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_company" in value;
    isInstance = isInstance && "goal_list" in value;

    return isInstance;
}

export function CreateCallExecutionRequestFromJSON(json: any): CreateCallExecutionRequest {
    return CreateCallExecutionRequestFromJSONTyped(json, false);
}

export function CreateCallExecutionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCallExecutionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility': !exists(json, 'facility') ? undefined : FacilityInfoFromJSON(json['facility']),
        'target_company': TargetCompanyFromJSON(json['target_company']),
        'goal_list': json['goal_list'],
        'patient_info': !exists(json, 'patient_info') ? undefined : PatientInfoFromJSON(json['patient_info']),
        'conference_phone_numbers': !exists(json, 'conference_phone_numbers') ? undefined : json['conference_phone_numbers'],
        'target_phone_number': !exists(json, 'target_phone_number') ? undefined : json['target_phone_number'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'member_state': !exists(json, 'member_state') ? undefined : json['member_state'],
    };
}

export function CreateCallExecutionRequestToJSON(value?: CreateCallExecutionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility': FacilityInfoToJSON(value.facility),
        'target_company': TargetCompanyToJSON(value.target_company),
        'goal_list': value.goal_list,
        'patient_info': PatientInfoToJSON(value.patient_info),
        'conference_phone_numbers': value.conference_phone_numbers,
        'target_phone_number': value.target_phone_number,
        'user_id': value.user_id,
        'user_name': value.user_name,
        'member_state': value.member_state,
    };
}

